var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"player-icon",attrs:{"type":"button"}},[_c('Icon',{attrs:{"type":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }